module.exports = __webpack_public_path__ + "assets/importQuestions.7c374fb5.svg";